export default "__VITE_ASSET__DYvIGx6F__"